import { CSSProperties, useState } from 'react'

import { Text } from '@hhgtech/hhg-components'
import { useIntl } from 'react-intl'

import Sort from '../icons/Sort'
import { TreePopoverMenu } from '../popoverMenu/treePopoverMenu'
import { LabelSortPin } from './index'

export enum LabelSortingValue {
  latest = 'latest',
  oldest = 'oldest',
  popular = 'popular',
}

export type ChoiceItem = {
  label: string
  value: string
}

export type Props = {
  onChange?: (v: string) => void
  color?: 'gray' | 'white'
  className?: string
  style?: CSSProperties
  leftLabel?: string
  rightLabel?: string
  value?: LabelSortingValue
  choices?: ChoiceItem[]
}

export const LabelSorting = ({
  onChange,
  className,
  style,
  leftLabel,
  rightLabel,
  color,
  value,
  choices,
}: Props) => {
  return (
    <LabelSortPin
      label={leftLabel}
      rightLabel={
        <TreePopoverMenu
          data={{
            isShowheader: false,
            type: 'list',
            list: choices?.map((c) => ({
              label: c.label || '',
              onClick: () => onChange && onChange(String(c.value)),
              selected: c.value === value,
              className: 'bold-item',
            })),
          }}
          toggleButtonContent={
            <div
              style={{
                display: 'flex',
              }}
            >
              <Text
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  fontWeight: 'normal',
                  marginRight: 12,
                }}
                size="p4"
              >
                {rightLabel}
              </Text>
              <Sort />
            </div>
          }
          position="bottom"
          align="end"
        />
      }
      color={color || 'gray'}
      className={className}
      style={style}
    />
  )
}

// HOOKS for use with this component
export const useSortChoices = (choices: ChoiceItem[]) => {
  const [selectedValue, setSelectedValue] = useState<LabelSortingValue>(
    LabelSortingValue.latest,
  )
  const selectedChoice = choices?.find((c) => c.value === selectedValue)

  return {
    setSortChoiceValue: setSelectedValue,
    selectedSortChoice: selectedChoice,
    sortedChoices: choices,
  }
}
export const useSortCommentChoices = () => {
  const { formatMessage: f } = useIntl()
  return useSortChoices([
    {
      label: f({ id: 'choicePopover.latest' }),
      value: LabelSortingValue.latest,
    },
    {
      label: f({ id: 'choicePopover.oldest' }),
      value: LabelSortingValue.oldest,
    },
  ])
}
